import $ from 'jquery'
import { $elementIsPassword } from './shared'

const INPUT_DATA_ATTRIBUTE = 'data-toggle-visibility'
const TOGGLE_BUTTON_CLASS = 'password__eye'
const PASSWORD_HIDDEN_ICON_CLASS = 'icon-eye-blocked'
const PASSWORD_SHOWN_ICON_CLASS = 'icon-eye'

export const initPasswordToggleInputs = () => {
    $('form input[' + INPUT_DATA_ATTRIBUTE + ']').each((index, element) => {
        initToggle($(element))
    })
}

const initToggle = ($input) => {
    const $inputGroup = $input.parents('.input-group')
    const $button = $inputGroup.find('a.' + TOGGLE_BUTTON_CLASS)
    const $icon = $button.find('i')

    $button.on('click', (e) => {
        e.preventDefault()
        const isHidden = $elementIsPassword($input)

        isHidden && show($input, $icon)
        !isHidden && hide($input, $icon)
    })
}

const show = ($input, $icon) => {
    $input.attr('type', 'text')
    $icon.removeClass().addClass(PASSWORD_SHOWN_ICON_CLASS)
}

const hide = ($input, $icon) => {
    $input.attr('type', 'password')
    $icon.removeClass().addClass(PASSWORD_HIDDEN_ICON_CLASS)
}
